import { redirect, type RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';
import { paths } from '@/app/router/paths';

/** /applications/* – child paths are relative to the parent segment. */
export const applicationsRoutes: RouteObject = {
  path: 'applications',
  children: [
    // /applications on its own opens the default list.
    { index: true, loader: () => redirect(paths.applications.all) },
    {
      path: 'all',
      handle: handle('allApplications'),
      lazy: () => import('./ApplicationsPages').then((m) => ({ Component: m.AllApplicationsPage })),
    },
    {
      path: 'action-required',
      handle: handle('actionRequired'),
      lazy: () => import('./ApplicationsPages').then((m) => ({ Component: m.ActionRequiredPage })),
    },
    {
      path: 'drafts',
      handle: handle('drafts'),
      lazy: () => import('./ApplicationsPages').then((m) => ({ Component: m.DraftsPage })),
    },
  ],
};
